import React from 'react';
import './TrustedSection.css';

// Provide both light and dark logo URLs for each company
const companies = [
  {
    name: 'Google',
    light: 'https://cdn.brandfetch.io/id6O2oGzv-/theme/dark/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B',
    dark: 'https://cdn.brandfetch.io/id6O2oGzv-/theme/dark/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B' // uses same due to colorful logo
  },
  {
    name: 'TCS',
    light: 'https://cdn.brandfetch.io/idK2mWG2SJ/theme/dark/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B',
    dark: 'https://cdn.brandfetch.io/idK2mWG2SJ/w/6000/h/6000/theme/light/logo.png?c=1dxbfHSJFAPEGdCLU4o5B'
  },
  {
    name: 'Meta',
    light: 'https://cdn.brandfetch.io/idWvz5T3V7/theme/dark/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B',
    dark: 'https://cdn.brandfetch.io/idWvz5T3V7/theme/light/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B'
  },
  {
    name: 'Infosys',
    light: 'https://cdn.brandfetch.io/id2jVuQy_9/theme/dark/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B',
    dark: 'https://cdn.brandfetch.io/id2jVuQy_9/theme/light/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B'
  },
  {
    name: 'IBM',
    light: 'https://upload.wikimedia.org/wikipedia/commons/5/51/IBM_logo.svg',
    dark: 'https://upload.wikimedia.org/wikipedia/commons/5/51/IBM_logo.svg'
  },
  {
    name: 'Capgemini',
    light: 'https://cdn.brandfetch.io/idbJBNV8BD/theme/dark/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B',
    dark: 'https://cdn.brandfetch.io/idbJBNV8BD/theme/dark/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B'
  },
  {
    name: 'Amazon',
    light: 'https://cdn.brandfetch.io/idawOgYOsG/theme/dark/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B',
    dark: 'https://cdn.brandfetch.io/idawOgYOsG/theme/light/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B'
  },
  {
    name: 'Microsoft',
    light: 'https://cdn.brandfetch.io/idchmboHEZ/theme/dark/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B',
    dark: 'https://cdn.brandfetch.io/idchmboHEZ/theme/dark/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B'
  },
  {
    name: 'Wipro',
    light: 'https://cdn.brandfetch.io/id1uICo497/theme/dark/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B',
    dark: 'https://cdn.brandfetch.io/id1uICo497/theme/dark/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B'
  },
  {
    name: 'Deloitte',
    light: 'https://cdn.brandfetch.io/idIu-Ji9Le/theme/dark/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B',
    dark: 'https://cdn.brandfetch.io/idIu-Ji9Le/theme/light/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B'
  },
  {
    name: 'KPMG',
    light: 'https://cdn.brandfetch.io/id-UmnExAG/theme/dark/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B',
    dark: 'https://cdn.brandfetch.io/id-UmnExAG/theme/light/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B'
  }
];

const TrustedSection = ({ theme }) => (
  <section className={`trusted-section theme-${theme}`}>
    <h2 className="trusted-title">
      <span>TRUSTED BY JOB SEEKERS WHO’VE LANDED ROLES AT TOP-TIER COMPANIES.</span>
      <br />
      <span className="trusted-bytext">
        OUR USERS HAVE BEEN HIRED BY LEADING NAMES IN THE INDUSTRY
      </span>
    </h2>
    <div className="marquee">
  <div className="marquee-track">
    {[...companies, ...companies].map((c, i) => (
      <div className="company-logo" key={c.name + '-' + i}>
        <img
          src={theme === 'dark' ? c.dark : c.light}
          alt={c.name}
          title={c.name}
        />
      </div>
    ))}
  </div>
</div>
  </section>
);

export default TrustedSection;
